import React, { useState, useRef } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import styled from 'styled-components';
import {RiAddCircleFill} from 'react-icons/ri';
import {GenerateIconByNoteType } from './NoteItem';
import './TextArea.css'
import { sendRequest, API_ROOT } from '../../supplementary_components/requests';
import { addNotification } from '../../supplementary_components/store';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { swapSVGWhileProcessing } from '../content_management/item_page/driver_page_components/payoutAdjustmentsSection';
const FormFrame = styled.form`
    box-shadow: 0 0 0 0.1rem var(--extra-light-gray);
    border-radius: 0.8rem;
    display: flex;
    align-items:center;
    width:100%;  
`;
const AddButton = styled.button`
    background: none;
    border: none;
    margin: 0 0.25rem ;
    *{
        width: 1.8rem;
        height: 1.8rem;
    }
    display: flex;
    justify-content:center;
    align-items:center;
    cursor:pointer;
`;
const CustomDropDownMenu = styled.div`
    position:relative;
    height:100%;
    width:3.7rem;
    
    .selctedIcon{
        cursor:pointer;
        height:100%;
        width:100%;
        display:flex;
        justify-content:center;
        align-items:center;
        padding-top:0.25rem;
        &>.option{
            margin-left:0.2rem;
            margin-right:0.2rem;
        }
        svg{
            fill:var(--gray);
        }
        border-right: thin solid var(--extra-light-gray);

    }
    .optionsBox{
        border-radius: 0.8rem 0.8rem 0 0 ;
        border: var(--extra-light-gray) solid;
        border-width: 1px 1px 1px 1px;
        background-color:var(--bg);
        position:absolute;
        top:-${props => props.$optionscount ?(props.$optionscount * 2): "6"}.2rem;
        left:-0.1rem;
        &>.connector{
            position:absolute;
            width:2.95rem;
            height:0.8rem;
            background-color:var(--bg);
            top:${props => props.$optionscount ?(props.$optionscount * 2): "6"}.0rem;
            left:-0.05rem;
            border-left: 1px var(--extra-light-gray) solid;
        }
        &>div{
            height:2rem;
            cursor:pointer;
            white-space:nowrap;
            display:flex;
            padding: 0.5rem;
            &>svg{
                fill:var(--gray);
                position:absolute;
            }
            &>span{
                color:var(--gray);
                margin-left:2rem;
                font-size:0.9rem;
                margin-right:1rem;
            }
            :hover{
                background-color:var(--extra-light-gray);
            }
        }
        &>div:nth-child(2){
            border-radius: 0.6rem 0.6rem 0 0 ;
        }
        
    }
`
 const NoteForm = ({currentUser, objectType, objectId, setNotes, setNotesFormHeight, setScrollNeeded, subjectsToAddNote, popup})=> {
    const [selectedOption, setSelectedOption] = useState(subjectsToAddNote ? subjectsToAddNote.truck : null);
    const [selecting, setSelecting] = useState(false);
    const iconRef = useRef(null);
    const formRef = useRef(null);
    const selectOption = (e) => {
        let target = e.target;
        while(target.className !== "option"){
            target = target.parentNode;
        }
        setSelectedOption(JSON.parse(target.dataset.val) );
        setSelecting(false);
    }

    const submitForm = (event)=> {
        event.preventDefault();
        if(event.target.noteMessage.value !== ''){
            const noteMessage = event.target.noteMessage.value;
            const dataObject = { 
                authorId: currentUser.id,
                authorName: currentUser.firstName,
                noteMessage: noteMessage,
                urgent: false,
                relevant: true,
                lastChangedBy: null
            };
            const link = API_ROOT+`${selectedOption ? selectedOption.type :  objectType}/addNote/${selectedOption ? selectedOption.id : objectId}`;
            
            // Get the SVG element
            const svgElement = iconRef.current?.querySelector('svg');
            if(!svgElement) return;
            
            // Create a promise-based action
            const addNoteAction = (data, metaInfo) => {
                return new Promise((resolve, reject) => {
                    const postSuccessAction = (responseData) => {
                        event.target.noteMessage.value = '';
                        setScrollNeeded(true);
                        if(!popup){
                            setNotes(oldNotes => ([...oldNotes, responseData]));
                        }
                        resolve(responseData);
                    };
                    const postErrorAction = (error) => {
                        addNotification({message:'Something went wrong',type:'alert'});
                        reject(error);
                    };
                    sendRequest('PATCH', link, null, postSuccessAction, postErrorAction, data);
                });
            };
            
            // Use swapSVGWhileProcessing
            const metaInfo = selectedOption ? `${selectedOption.type} note` : `${objectType} note`;
            swapSVGWhileProcessing(addNoteAction, svgElement, dataObject, metaInfo, null, 'var(--main-color)');
        }
    }
    let objectCount = -1;
    for(let key in subjectsToAddNote){
        if(subjectsToAddNote[key])objectCount += 1;
    }
    const handleKeyDown = (e) => {
        // Submit on Enter, but allow Shift+Enter for new lines
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (formRef.current) {
                const formEvent = new Event('submit', { bubbles: true, cancelable: true });
                formRef.current.dispatchEvent(formEvent);
                submitForm({ ...formEvent, target: formRef.current, preventDefault: () => {} });
            }
        }
    }
    
    return <FormFrame ref={formRef} onSubmit={submitForm}>
        {subjectsToAddNote ?
            <CustomDropDownMenu $optionscount={objectCount}>
                <div className="selctedIcon" onClick={()=>{setSelecting(prev => !prev)}}>
                    <div className="option"  data-val={"truck"}><GenerateIconByNoteType type={selectedOption.type} /></div>
                    <span>{selecting ?<IoIosArrowDown />:<IoIosArrowUp />}</span></div>
                {selecting ?
                    <div className="optionsBox">
                        <span className="connector"></span>
                        {optionGenerator(subjectsToAddNote.currentTrailer, selectedOption, "trailers", selectOption)}
                        {optionGenerator(subjectsToAddNote.driver2, selectedOption, "drivers", selectOption)}
                        {optionGenerator(subjectsToAddNote.driver1, selectedOption, "drivers", selectOption)}
                        {optionGenerator(subjectsToAddNote.truck, selectedOption, "trucks", selectOption)}
                    </div>
                :
                    null
                }
        
            </CustomDropDownMenu>
            :
            null
        }
       
        <TextareaAutosize
            onFocus={()=>{setSelecting(false)}}
            onKeyDown={handleKeyDown}
            minRows={1}
            maxRows={10}
            name="noteMessage"
            onHeightChange={(newHeight)=>{
                const height = newHeight === 16 ? newHeight : newHeight-5;
                setNotesFormHeight(height);
            }}
            style={{background: 'var(--bg)'}}
            placeholder="Write a note..."
            className="noteTextArea"
        />
        <AddButton type='submit' ref={iconRef}>
            <RiAddCircleFill style={{
                // margin:"auto auto 0px -5px",
                color: 'var(--main-color)',
                
            }} />
        </AddButton>
        
    </FormFrame>
}
export default NoteForm;


const optionGenerator = (possibleObject, selectedOption, type, selectOptionMethod) => {
    return <>{possibleObject && selectedOption.label !== possibleObject.label ? <div className="option" onClick={selectOptionMethod} data-val={JSON.stringify(possibleObject)}><GenerateIconByNoteType type={type} /><span>{possibleObject.label}</span></div> : null}</>
}